__turbopack_context__.v({
  "bottomBar": "PgjF_W_bottomBar",
  "content": "PgjF_W_content",
  "iconLabel": "PgjF_W_iconLabel",
  "icons": "PgjF_W_icons",
  "logoLink": "PgjF_W_logoLink",
  "menuIcon": "PgjF_W_menuIcon",
  "navLink": "PgjF_W_navLink",
  "navLinks": "PgjF_W_navLinks",
  "navbarRightWrapper": "PgjF_W_navbarRightWrapper",
  "onlyTabletContent": "PgjF_W_onlyTabletContent",
  "wrapper": "PgjF_W_wrapper",
});
